
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ValueProposition from './components/ValueProposition';
import CredibilitySection from './components/CredibilitySection';
import CTASection from './components/CTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <HeroSection />
      <ValueProposition />
      <CredibilitySection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
